import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: {
    button: 'Подать заявку на кредит',
    title: 'Инвестиционный кредит',
    description:
      'Сезонный график погашения. Можно использовать для погашения других кредитов. Без залога — до 5 млн руб. Срок кредита — до 15 лет',
  },
  benefits: {
    title: 'Простая подача <br/>заявки',
    description: {
      individualConditions: 'Индивидуальные условия',
      flexibleSchedule: 'Гибкий график погашения',
      remoteSolution: 'Дистанционное решение',
    },
    text: {
      individualConditions: 'Решение по процентной ставке с учетом особенностей вашего хозяйства',
      flexibleSchedule: 'Погашайте по мере поступления денег с отсрочкой до 12 месяцев',
      remoteSolution: 'В пределах 3 рабочих дней со дня предоставления полного пакета документов',
    },
  },
  affiliation: {
    description:
      '<ul class="list-with-marks"><li>Срок деятельности ИП / (Г)КФХ / ООО от 6 месяцев;</li><li>Годовая выручка не более 400 млн руб;</li><li>Отсутствие просроченной задолженности по кредитам и налогам свыше 50 тыс. руб.</li></ul>',
  },
  steps: {
    title: 'Этапы получения средств',
    '1': 'Заполнить заявку онлайн на поле.рф',
    '2': 'Консультация с менеджером Сбербанка',
    '3': 'Подготовка необходимых документов',
    '4': 'Дождаться решения о выдаче кредита',
    '5': 'Подписание документов и получение средств',
    button: 'Подать заявку',
  },
  conditions: { title: 'Условия кредитования' },
  form: { title: 'Подайте заявку на кредит уже сейчас!' },
  financingOffer: {
    hint: {
      forAgrariansOnly: 'Доступно только для аграриев',
    },
    details: {
      freeOrder: {
        value: 'до 5 млн ₽',
        sign: 'без залога',
      },
      order: {
        value: 'более 5 млн ₽',
        sign: 'с залогом',
      },
      preferentialRate: {
        value: 'от 1%',
        sign: 'льготная ставка',
      },
      deadment: {
        value: 'до 12 мес.',
        sign: 'отсрочка погашения',
      },
    },
  },
  breadcrumb: 'Инвестиционный кредит',
} satisfies TMessages
